module.exports = {
	"articleTitle1": "Cockroaches return to Mary Markley ",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Mary Markley Hall",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/campus-life/otd-markley-residents-send-message-osu",
	"articleSnippet1": "Oct 12, 2016 ... Mary Markley Residence Hall is the largest student dorm on Central Campus at \nthe University of Michigan and along with housing more than ...",
	"articleSnippet2": "Nov 22, 2016 ... After a “Children of Yost” Twitter post on Monday morning suggested the idea, \nresidents on the back side of Mary Markley hall used lights in ...",
	"totalMisc": 0,
	"articleTitle2": "OTD: Markley residents send message to OSU ",
	"address": "1503 Washington Heights, Ann Arbor, MI 48109",
	"images": [],
	"position": {
		"lat": 42.280921,
		"lng": -83.728797
	},
	"tips": [
		{
			"text": "Engineers, the commuter north station in the back is very helpful in the morning.",
			"person": "Bob Lesser"
		},
		{
			"text": "Watch out for the cockroaches",
			"person": "Bob Lesser"
		}
	],
	"bathroomrating": [
		{
			"ranking": 1,
			"bathroom": "Dorm Bathrooms"
		}
	],
	"categories": {
		"dorm": 1,
		"misc": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/markley.json
// module id = 912
// module chunks = 0